import React, { useEffect, useState, useRef } from 'react'
import BackButton from '../components/BackButton';
import Sidebar from '../components/Sidebar';
import { useLocation } from "react-router-dom";
import { HeartPlus, ArrowLeft } from 'lucide-react';
import Card_1 from '../components/Card_1';
import MobileNav from '../components/MobileNav';


export default function Favorites() {
    const [SelectedChannel, setSelectedChannel] = useState(0);

    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        const data = localStorage.getItem("PK_Favorites");
        if (data) {
            const parsed = JSON.parse(data);
            setFavorites(parsed || []);
        }
    },[])

    return (
        <div>
            <Sidebar SelectedChannel={SelectedChannel}
                onChannelSelect={(index) => setSelectedChannel(index)}
            />

            <section className='body_section'>
                <BackButton />
                <h2 className='bold mt-2' >Favorites</h2>

                {favorites.length > 0 ? (
                    <div className='video_card_grid'>
                        {favorites.map((video, index) => (
                            <Card_1 video={video} />
                        ))}
                    </div> // ✅ Close .map() and .video_card_grid
                ) : (
                    <div
                        className='d-flex flex-column align-items-center mt-5 p-5'
                        style={{ backgroundColor: '#f4f4f4', borderRadius: '15px' }}
                    >
                        <HeartPlus size={100} color='red' style={{ borderRadius: '15px' }} />
                        <h3 className='bold'>No Favorites</h3>
                        <p className='text-center'>
                            You can go back to the home page <br /> and add videos to favorites.
                        </p>
                        <button className='btn btn-primary' onClick={() => (window.location.href = '/')}>
                            <ArrowLeft /> Go Back
                        </button>
                    </div>
                )}






            </section>

            <MobileNav/>


        </div>
    )
}
